import { render, staticRenderFns } from "./channelBar.vue?vue&type=template&id=f15c07fe&scoped=true&"
import script from "./channelBar.vue?vue&type=script&lang=js&"
export * from "./channelBar.vue?vue&type=script&lang=js&"
import style0 from "./channelBar.vue?vue&type=style&index=0&id=f15c07fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15c07fe",
  null
  
)

export default component.exports